import Api from '@/api'

export default {
  state: {panel_data: []},
  actions: {
    async LOAD_DASHBOARD_TABS({}) {
      try {
        const res = await Api.load_dashboard_tabs()
        const code = res.status
        if (code === 200) {
          return res.data
        } else {
          throw 'Load dashboard tabs error'
        }
      } catch (err) {
        throw err
      }
    },
    async LOAD_DASHBOARD_TAB_DATA({commit}, id) {
      try {
        const res = await Api.load_dashboard_tab_data(id)
        const {status, data} = res
        if (status === 200) {
          commit('SET_PANEL_DATA', data)
        } else {
          throw `Load dashboard tab data status ${status}`
        }
      } catch (err) {
        throw `Load dashboard: ${err}`
      }
    }
  },
  mutations: {
    SET_PANEL_DATA(state, data) {
      state.panel_data = {...data}
    }
  },
  getters: {}
}
